import { useEffect, useState } from "react";
import { IconButton } from "../../../../core/shared/buttons/IconButton";
import { toast } from "react-toastify";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { PiSuitcaseSimple } from "react-icons/pi";
import { NoResults } from "../../../../core/shared/NoResults";
import { LuFileBadge, } from "react-icons/lu";
import { TbPigMoney } from "react-icons/tb";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _EmployeeContract, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { MenuButton } from "../../../pages/DefaultHomePage/Dashed/components/MenuButton/MenuButton";
import { QuickAction } from "../../../pages/DefaultHomePage/Dashed/components/MenuDashed/MenuDashed";

export const EmployeeContract = () => {

    const certificateTabs: QuickAction[] = [
        { label: 'Laborales', icon: <PiSuitcaseSimple />, event: () => { setActiveTab(0) } },
        { label: 'Tributarios', icon: <TbPigMoney />, event: () => { setActiveTab(1) } },
    ]
    const { instance } = useDataBean(_EmployeeContract)

    const [props, setProps] = useState<any>(
        {
            downloading: false,
            includeSalary: false,
            listFortnight: [],
            listDocuments: [],
            url: '#',
        }
    );

    const [documentList, setDocumentList] = useState<any[]>([]);
    const [typeCetificate, setTypeCetificate] = useState<any>('1');
    const [certificateTypes, setCertificateTypes] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [year, setYear] = useState(_single.getCurrenYear());

    const modalDoc = useModal("Documento", MODAL_XL);

    useEffect(() => {
        getDocumentTemplateCatalog()
    }, [activeTab])

    useEffect(() => {
        searchList();
    }, [typeCetificate, activeTab])


    const searchList = () => {
        instance.getEmployeeContract(_single.getAccountID()).then(
            (resp: any) => {
                setProps({ ...props, "listFortnight": resp });
            }
        ).catch(err => { toast.error(err) })
    }

    const getDocumentParsed = (idContract: number) => {
        setProps({ ...props, downloading: true })
        const docProps = {
            Year: year,
            IDAccount: _single.getAccountID()
        }
        instance.getDocumentTemplateParsed(typeCetificate, activeTab === 0 ? { IDContract: idContract } : docProps, 'DOCX').then(
            (resp: any) => {
                if (resp.length > 0) {
                    setDocumentList(resp);
                    modalDoc.open();
                } else {
                    toast.error('No se genero ningun certificado')
                    setProps({ ...props, downloading: false })
                }
            }).catch(
                err => {
                    toast.error('Error en la solicitud')
                }
            )
    }

    const getDocumentTemplateCatalog = () => {
        instance.getDocumentTemplateCatalog(4, activeTab === 0 ? 'PAYROLL_CERTS' : 'PAYROLL_DIAN', true).then(
            (resp: any) => {
                if (resp) {
                    setCertificateTypes(resp);
                    if (resp.length > 0) {
                        setTypeCetificate(resp[0].DataBeanProperties.IDDocumentTemplate)
                    }
                }
            }).catch(
                err => { toast.error(err) }
            )
    }

    return (
        <div className="row mx-2 d-flex justify-content-between">
            <div className="col-12">
                <div className="d-flex gap-5 justify-content-between">
                    {certificateTabs.map((e, i) =>
                        <MenuButton key={i} item={e} labelSize={16} active={activeTab === i} />
                    )}
                </div>
            </div>
            <div className="d-flex gap-2 justify-content-center align-items-center">
                <div className="mt-3">
                    <label>Tipo de certificado</label>
                    <select className="form-select form-select-sm" value={typeCetificate} onChange={(e) => { setTypeCetificate(e.target.value); }}>
                        {certificateTypes.map((_e, index) =>
                            <option key={index} value={_e.DataBeanProperties.IDDocumentTemplate}>{_e.DataBeanProperties.Name}</option>
                        )}
                    </select>
                </div>
                {activeTab === 1 &&
                    <div className="w-50">
                        <YearSelector size="sm" value={year} onChange={setYear} />
                    </div>
                }
            </div>
            <div className="col-12">
                {props.listFortnight.length > 0 ?
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-center">
                            <ul className="p-0 m-0 overflow-y-hidden" style={{ width: "80%" }}>
                                {props.listFortnight.map((_e: any, _i: number) => (
                                    <li key={_i} className="d-flex mb-4 pb-3 border-bottom">
                                        <div className="avatar flex-shrink-0 me-3">
                                            <div style={{ color: '#006699', fontSize: '60px' }}>
                                                <LuFileBadge />
                                            </div>
                                        </div>
                                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                            <div className="me-2">
                                                <small className="text-muted d-block mb-1">{_e.DataBeanProperties.Period}</small>
                                                <h6 className="mb-0">{`Certificación ${activeTab === 0 ? 'Laboral' : 'Tributaria'}`}</h6>
                                                <small className="">{_e.DataBeanProperties.EntailmentName}</small>
                                                <small className="">{_e.DataBeanProperties.EmploymentTypeName}</small>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <IconButton
                                                    icon="ri-file-download-line"
                                                    event={() => getDocumentParsed(_e.DataBeanProperties.IDContract)}
                                                />
                                            </div>

                                        </div>
                                    </li>
                                ))}
                            </ul>

                        </div>
                    </div>
                    : <NoResults className="mt-5 pt-3" />
                }
            </div>
            <div className="col-md-12">
                <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                    <div className="row">
                        <div className="col-md-12">
                            {documentList.length > 0 ? (
                                documentList.map((documents) => {
                                    const doc = documents.DataBeanProperties;
                                    return (
                                        <VisorAnyDocument type={doc.Type} url={doc.URLLink} />
                                    )
                                })
                            ) : (
                                <NoResults className="mt-5 pt-3" />
                            )}
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}